import { DocumentStatus } from 'common-src/models/PatientDocument';

import { DocumentTabs } from './constants';

export const getTabInfo = (documents = []) => {
  const uploadedDocuments = [];
  const deletedDocuments = [];

  [...documents]
    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
    .forEach((doc) => {
      if (![DocumentStatus.Uploaded].includes(doc.status)) {
        deletedDocuments.push(doc);
        return;
      }

      uploadedDocuments.push(doc);
    });

  const tabInfo = {
    UPLOADED: {
      text: DocumentTabs.UPLOADED.text,
      count: uploadedDocuments.length,
    },
    DELETED: {
      text: DocumentTabs.DELETED.text,
      count: deletedDocuments.length,
    },
    ALL: {
      text: DocumentTabs.ALL.text,
      count: documents.length,
    },
  };

  return {
    tabInfo,
    uploadedDocuments,
    deletedDocuments,
    allDocuments: documents,
  };
};
